var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var defaultMessages = require('../../i18n/messages/default');

class TryOtherWays extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showMFAMethods: false
        };
    }

    render() {
        return (
        <div className="pull-right cursor">
            <a onClick={this.props.showMFAMethods} className="blue-labels">
                {this.props.intl.formatMessage(defaultMessages['try_other_ways'])}
            </a>
        </div> 
        );
    }
}

module.exports = injectIntl(TryOtherWays);